// SPDX-License-Identifier: AGPL-3.0-or-later

import {CreatePollModal} from '@app/features/poll/components/modals/CreatePollModal';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {modal} from '@app/features/ui/commands/ModalCommands';

export function openCreatePollModal(channelId: string): void {
	ModalCommands.push(modal(() => <CreatePollModal channelId={channelId} />));
}
